export const BRAND = {
  name: "LAKA CLUB BEAUTY",
  slogan: "Donde la belleza se convierte en bienestar",
  subtitle: "Estética avanzada & bienestar",
  phone: "+34 744 43 04 43",
  phoneHref: "tel:+34744430443",
  whatsapp: "+34 744 43 04 43",
  whatsappNumber: "34744430443",
  email: "lakabeauty@lakamoda.com",
  address:
    "Eduardo Criado nº20, local comercial, CP 23740, Andújar, Jaén, España",
  city: "Andújar, Jaén",
  instagram: "@lakaclubbeauty",
  instagramUrl: "https://instagram.com/lakaclubbeauty",
};

export const NAV_LINKS = [
  { id: "inicio", label: "Inicio" },
  { id: "tratamientos", label: "Tratamientos" },
  { id: "precios", label: "Precios" },
  { id: "membresias", label: "Membresías" },
  { id: "centro", label: "El Centro" },
  { id: "opiniones", label: "Opiniones" },
  { id: "contacto", label: "Contacto" },
];

export const CATEGORIES = [
  {
    key: "laser",
    label: "Depilación láser",
    short: "Láser",
    tag: "01",
    text: "Sesiones rápidas y adaptadas a cada zona para conseguir una piel suave y cómoda de forma progresiva.",
    image:
      "https://images.pexels.com/photos/36930637/pexels-photo-36930637.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  },
  {
    key: "facial",
    label: "Faciales glow & limpieza avanzada",
    short: "Facial",
    tag: "02",
    text: "Tratamientos diseñados para renovar, iluminar y mejorar la textura de la piel desde la primera sesión.",
    image:
      "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "led",
    label: "Fototerapia LED",
    short: "Fototerapia",
    tag: "03",
    text: "Tecnología lumínica para mejorar el aspecto de la piel, tratar imperfecciones y potenciar la luminosidad.",
    image:
      "https://images.unsplash.com/photo-1573461160327-b450ce3d8e7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "firmeza",
    label: "Rejuvenecimiento y firmeza",
    short: "Firmeza",
    tag: "04",
    text: "Protocolos orientados a firmeza, definición y rejuvenecimiento sin cirugía.",
    image:
      "https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "corporal",
    label: "Corporal y bienestar",
    short: "Corporal",
    tag: "05",
    text: "Tratamientos corporales para acompañar objetivos de remodelación, bienestar y cuidado personal.",
    image:
      "https://images.unsplash.com/photo-1600334129128-685c5582fd35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    key: "beauty",
    label: "Beauty complementario",
    short: "Beauty",
    tag: "06",
    text: "Un extra beauty para completar una imagen cuidada y luminosa.",
    image:
      "https://images.unsplash.com/photo-1607779097040-26e80aa78e66?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const TREATMENTS = [
  // Láser
  { cat: "laser", name: "Zona mini", price: 10, duration: "15 min" },
  { cat: "laser", name: "Zona mediana", price: 25, duration: "20 min" },
  { cat: "laser", name: "Zona grande", price: 40, duration: "30 min" },
  {
    cat: "laser",
    name: "Pack piernas completas + ingles + axilas",
    price: 60,
    duration: "45 min",
  },
  {
    cat: "laser",
    name: "Pack cuerpo completo (hombre y mujer)",
    price: 99,
    duration: "1 h",
  },
  // Facial
  {
    cat: "facial",
    name: "Punta de diamante & peeling ultrasónico",
    price: 30,
    duration: "30 min",
  },
  {
    cat: "facial",
    name: "Cóctel de vitaminas con dermapen & máscara LED",
    price: 40,
    duration: "40 min",
  },
  { cat: "facial", name: "BB Glow", price: 60, duration: "1 h" },
  {
    cat: "facial",
    name: "Pack Piel Radiante — diamante, peeling & LED",
    price: 45,
    duration: "45 min",
    featured: true,
  },
  // LED
  { cat: "led", name: "Tratamiento acné + máscara LED", price: 45, duration: "40 min" },
  { cat: "led", name: "Fotorejuvenecimiento", price: 30, duration: "30 min" },
  { cat: "led", name: "Despigmentante", price: 30, duration: "30 min" },
  // Firmeza
  { cat: "firmeza", name: "Radiofrecuencia", price: 30, duration: "30 min" },
  { cat: "firmeza", name: "HIFU una zona facial", price: 59, duration: "45 min" },
  {
    cat: "firmeza",
    name: "HIFU facial completo & cuello",
    price: 149,
    duration: "1 h",
  },
  {
    cat: "firmeza",
    name: "HIFU una zona corporal",
    price: 199,
    duration: "1 h 30 min",
  },
  { cat: "firmeza", name: "Hilos mágicos de colágeno", price: 65, duration: "45 min" },
  // Corporal
  { cat: "corporal", name: "Cavitación", price: 30, duration: "30 min" },
  // Beauty
  { cat: "beauty", name: "Blanqueamiento dental", price: 59, duration: "1 h" },
];

export const MEMBERSHIPS = [
  {
    key: "silver",
    name: "LAKA Silver",
    price: 49,
    tagline: "Inicio del ritual beauty",
    benefits: [
      "Diagnóstico beauty personalizado",
      "10% de descuento en tratamientos",
      "Prioridad básica en agenda",
      "Acceso a novedades",
    ],
  },
  {
    key: "gold",
    name: "LAKA Gold",
    price: 79,
    tagline: "El equilibrio perfecto",
    highlighted: true,
    benefits: [
      "Todo lo incluido en Silver",
      "15% de descuento en tratamientos",
      "Sesión mensual incluida",
      "Prioridad reforzada en agenda",
      "Promociones exclusivas Gold",
    ],
  },
  {
    key: "black",
    name: "LAKA Black",
    price: 119,
    tagline: "Experiencia premium ilimitada",
    benefits: [
      "Todo lo incluido en Gold",
      "20% de descuento en tratamientos",
      "Dos sesiones mensuales incluidas",
      "Reserva prioritaria absoluta",
      "Regalo beauty en tu cumpleaños",
    ],
  },
];

export const METHOD_STEPS = [
  { n: "01", title: "Escuchamos tu objetivo", text: "Conocemos lo que buscas, tus rutinas y expectativas." },
  { n: "02", title: "Analizamos tu piel", text: "Estudio de la piel o zona a tratar para diseñar el mejor protocolo." },
  { n: "03", title: "Diseñamos tu protocolo", text: "Un plan personalizado con tecnología y tiempos adaptados." },
  { n: "04", title: "Realizamos el tratamiento", text: "Experiencia cuidada, técnica precisa y ambiente boutique." },
  { n: "05", title: "Seguimiento", text: "Acompañamos la evolución para asegurar resultados naturales y visibles." },
];

export const TESTIMONIALS = [
  {
    quote:
      "Me hice el Pack Piel Radiante y noté la piel mucho más luminosa desde la primera sesión.",
    author: "Marta G.",
    role: "Cliente · Facial",
  },
  {
    quote:
      "La depilación láser fue rápida y muy cómoda. Me explicaron cada paso antes de empezar.",
    author: "Lucía R.",
    role: "Cliente · Láser",
  },
  {
    quote:
      "Me sentí muy tranquila desde el minuto uno. Se nota que cuidan hasta el último detalle.",
    author: "Carmen P.",
    role: "Cliente · Firmeza",
  },
  {
    quote:
      "El centro transmite mucha calma. Es mi rincón favorito para desconectar y cuidarme.",
    author: "Andrea M.",
    role: "Miembro Gold",
  },
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Recepción del centro",
    label: "Recepción",
  },
  {
    src: "https://images.unsplash.com/photo-1540555700478-4be289fbecef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Cabina de tratamientos",
    label: "Cabina",
  },
  {
    src: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    alt: "Detalle beauty",
    label: "Detalle beauty",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const buildWhatsAppLink = (message) => {
  const base = `https://wa.me/${BRAND.whatsappNumber}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
